import Api from '@/services/Api'

const URL = 'tareas/tarea';
const ACCION_AGREGAR_COMENTARIO = 'agregar_comentario';

export default {

    fetch(params) {
        return Api().get(URL, {
            params: params
        });
    },

    getById(codigo) {
        return Api().get(`${URL}${codigo}`);
    },

    save(params) {
        if ('id' in params) {
            return Api().put(`${URL}${params.id}` + '/', params);
        }
        return Api().post(uRL, params);
    },

    agregar_comentario(id, params) {
        return Api().post(`${URL}${id}/${ACCION_AGREGAR_COMENTARIO}/`, params);
    },

}